import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { MACHINE_TYPES } from 'constants/machines'

const LEGS = [...Array(4).keys()]
const WHEELS = [...Array(6).keys()]

function MachineStand({ variant }) {
  if (variant === MACHINE_TYPES.manual_machine) {
    return (
      <div className="machine-stand__table-legs">
        <div className="machine-stand__table" />
        <div className="machine-stand__legs">
          {LEGS.map((leg) => (
            <div key={`machine-leg-${leg}`} className="machine-stand__leg" />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className={`machine-stand__continous-track machine-stand__continous-track--${variant}`}>
      {WHEELS.map((wheel) => (
        <div
          key={`machine-stand-wheel-${wheel}`}
          className={`machine-stand__wheel machine-stand__wheel--${variant}`}
        />
      ))}
    </div>
  )
}

MachineStand.propTypes = {
  variant: PropTypes.string.isRequired
}

export default memo(MachineStand)
